export default {
  // 頁面標題
  title: '預警設置',
  // 預警監控規則
  sectionAlertRule: '預警監控規則',
  alertEnabled: '功能開關',
  alertEnabledDesc: '開啟後，當某個二維碼達到設定的掃碼次數後，系統將自動觸發預警。',
  scanCountThreshold: '預警掃碼次數閾值',
  scanCountThresholdUnit: '次',
  scanCountThresholdDesc: '設置觸發預警的掃碼次數，當二維碼被掃描次數達到此數值時觸發預警。',
  // 自動化處置策略
  sectionAutoDispose: '自動化處置策略',
  autoDisposeEnabled: '功能開關',
  autoDisposeEnabledDesc: '開啟後，當二維碼觸發預警時，系統將自動禁用二維碼，阻止繼續被掃描。',
  triggerCondition: '觸發條件',
  triggerOnScanCount: '觸發掃碼次數預警時',
  executeAction: '執行禁用操作',
  disableScopeSingle: '禁用預警的二維碼',
  disableScopeBatch: '禁用同批次所有二維碼',
  disableTip: '禁用提示語（消費者端文案）',
  disableTipDesc: '設置當消費者掃描被禁用的二維碼時，手機端顯示的提示內容。',
  disableTipPlaceholder: '請輸入禁用提示語',
  // 保存
  save: '保存',
  saveSuccess: '保存成功',
};
